import * as React from 'react';

const LineWorksLogoSVG = props => {
  return (
    <svg
      id='prefix__\u30EC\u30A4\u30E4\u30FC_1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='87 34 212 28'
      xmlSpace='preserve'
      {...props}
    >
      <style>{'.prefix__st0{fill:#00c73c}'}</style>
      <switch>
        <g>
          <path
            className='prefix__st0'
            d='M203.8 35.3h-4.1c-.4 0-.7.3-.8.6l-4.2 15.8-4.2-15.8c-.1-.4-.4-.6-.8-.6H185c-.4 0-.7.3-.8.6L180 51.6l-4.3-15.8c-.1-.4-.4-.6-.8-.6h-4.1c-.6 0-1 .5-.8 1.1l6.9 23.7c.1.4.4.6.8.6h4.6c.4 0 .7-.3.8-.6l4.2-14.7 4.2 14.7c.1.4.4.6.8.6h4.6c.4 0 .7-.3.8-.6l6.9-23.7c.2-.5-.2-1-.8-1zM218.3 34.7c-7.4 0-13.4 6-13.4 13.3 0 7.4 6 13.3 13.4 13.3s13.4-6 13.4-13.3c-.1-7.4-6.1-13.3-13.4-13.3zm0 20.7c-3.8 0-6.9-3.3-6.9-7.4s3.1-7.4 6.9-7.4c3.8 0 6.9 3.3 6.9 7.4s-3.1 7.4-6.9 7.4zM248.3 50.7c2.8-1.3 4.9-3.9 4.9-7.2 0-5.2-4.4-8.2-9.8-8.2h-8.1c-.6 0-1 .5-1 1v23.4c0 .6.5 1 1 1h3.8c.6 0 1-.5 1-1v-8h2l4.5 8.5c.2.3.5.5.9.5h5.5c.3 0 .5-.3.4-.6l-5.1-9.4zm-4.8-4.2h-3.3v-6.1h3.3c2.6 0 3.9 1.4 3.9 3 0 3-3.6 3.1-3.9 3.1zM269.4 47.7l7.3-11.8c.2-.3 0-.7-.4-.7h-5.2c-.4 0-.7.2-.9.5l-5.9 9.5h-1.9v-8.9c0-.6-.5-1-1-1h-3.8c-.6 0-1 .5-1 1v23.4c0 .6.5 1 1 1h3.8c.6 0 1-.5 1-1v-8.9h2l6.1 9.5c.2.3.5.5.9.5h5.6c.3 0 .5-.4.4-.7l-8-12.4zM290.6 45.7c-5.6-1.6-5.7-2.8-5.7-3.6 0-.9.7-2.2 3.2-2.2 2.1 0 3.9.9 5.2 2 .4.3 1 .3 1.4 0l2.4-2.4c.4-.4.4-1 0-1.4-1.1-1.2-3.8-3.4-9-3.4-3.3 0-9 2.1-9 7.6 0 7 7.6 7.7 10.4 8.8 3 1.3 2.3 2.8 2.1 3.4-.2.7-1.7 2-4.9 1.5-2-.3-3.4-1.3-4.2-2-.4-.4-1-.3-1.4 0l-2.5 2.4c-.4.4-.4 1 0 1.4 1.1 1.2 3.9 3.5 9.3 3.5 7.4 0 10-4.8 10-8 0-3-1.6-6-7.3-7.6zM113.2 35.3h-3.8c-.6 0-1 .5-1 1v23.4c0 .6.5 1 1 1h3.8c.6 0 1-.5 1-1V36.3c.1-.6-.4-1-1-1zM104.2 54.9H93.9V36.3c0-.6-.5-1-1-1h-3.8c-.6 0-1 .5-1 1v23.4c0 .6.5 1 1 1h15.1c.6 0 1-.5 1-1v-3.8c0-.6-.5-1-1-1zM159.9 35.3h-15.1c-.6 0-1 .5-1 1v23.4c0 .6.5 1 1 1h15.1c.6 0 1-.5 1-1v-3.8c0-.6-.5-1-1-1h-10.2V51h10.2c.6 0 1-.5 1-1v-3.8c0-.6-.5-1-1-1h-10.2v-4h10.2c.6 0 1-.5 1-1v-3.7c0-.8-.4-1.2-1-1.2zM139.1 35.3h-3.8c-.6 0-1 .5-1 1v13.8l-10.6-14.4c-.2-.3-.5-.5-.9-.5H119c-.6 0-1 .5-1 1v23.4c0 .6.5 1 1 1h3.8c.6 0 1-.5 1-1V45.8l10.7 14.5c.2.2.5.4.8.4h3.8c.6 0 1-.5 1-1V36.3c.1-.6-.4-1-1-1z'
          />
        </g>
      </switch>
    </svg>
  );
};

export const LineWorksLogo = ({ height = 24 }) => {
  if (height <= 12) {
    throw new Error('12px以下で使用できません。');
  }

  const logoSpace = `${height}px`;
  return (
    <div style={{ padding: logoSpace }}>
      <LineWorksLogoSVG style={{ height, display: 'block' }} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/icons/LineWorksLogo.jsx